module.exports = __webpack_public_path__ + "static/media/bahrain.de663065.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/bahrain.jpg
// module id = 41
// module chunks = 0